import { render, staticRenderFns } from "./WordTemplateModify.vue?vue&type=template&id=7fdbff22&scoped=true"
import script from "./WordTemplateModify.vue?vue&type=script&lang=js"
export * from "./WordTemplateModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdbff22",
  null
  
)

export default component.exports